import { useState, useRef, useEffect } from "react";

function CheckboxDropdown({ label, options, selected, onToggle, onSelectAll }) {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const allSelected = options.length > 0 && selected.length === options.length;

  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const displayText =
    selected.length === 0
      ? `Select ${label}`
      : allSelected
      ? `All ${label}`
      : `${selected.length} selected`;

  return (
    <div className="checkbox-dropdown" ref={dropdownRef}>
      <span className="vehicle-search-label">{label}</span>
      <button
        type="button"
        className="checkbox-dropdown-trigger"
        onClick={() => setIsOpen((prev) => !prev)}
        aria-expanded={isOpen}
      >
        {displayText}
        <span className={`checkbox-dropdown-arrow ${isOpen ? "open" : ""}`}>▼</span>
      </button>
      {isOpen && (
        <div className="checkbox-dropdown-panel">
          <label className="checkbox-dropdown-option checkbox-dropdown-all">
            <input
              type="checkbox"
              checked={allSelected}
              onChange={(e) => onSelectAll(e.target.checked)}
            />
            <span>All</span>
          </label>
          {options.map((option) => (
            <label key={option} className="checkbox-dropdown-option">
              <input
                type="checkbox"
                checked={selected.includes(option)}
                onChange={() => onToggle(option)}
              />
              <span>{option}</span>
            </label>
          ))}
        </div>
      )}
    </div>
  );
}

export default CheckboxDropdown;
